import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
import { useAxios } from 'shared/hooks/useAxios';
import {
  IAVAutomationCreatePayload,
  IAVAutomationDeletePayload,
  IAVAutomationRequestPayload,
  IAVAutomationResponsePayload,
  IAVAutomationUpdatePayload,
} from 'shared/interfaces/IAVAutomation';
import { transformPayload } from 'shared/utils/transformPayload';

export const useAVAutomationDao = () => {
  const { GET, POST, DELETE } = useAxios();

  const getAVAutomation = async (payload?: IAVAutomationRequestPayload) => {
    const transformedPayload = transformPayload<IAVAutomationRequestPayload>(payload);

    const response = await GET<IAVAutomationResponsePayload>({
      url: ENDPOINTS.AV_AUTOMATION,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  const getSingleAVAutomation = async (payload?: IAVAutomationRequestPayload) => {
    const transformedPayload = transformPayload<IAVAutomationRequestPayload>(payload);

    const response = await GET<IAVAutomationResponsePayload>({
      url: `${ENDPOINTS.AV_AUTOMATION}/show`,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  const createAVAutomation = async (payload?: {
    data?: IAVAutomationCreatePayload;
    youtube_image?: File;
    facebook_image?: File;
    recording_image?: File;
  }) => {
    const transformedPayload = transformPayload<IAVAutomationCreatePayload>(payload?.data);
    const formData = new FormData();
    formData.append('token', transformedPayload);

    if (payload?.youtube_image) {
      formData.append('youtube_image', payload.youtube_image);
    }
    if (payload?.facebook_image) {
      formData.append('facebook_image', payload.facebook_image);
    }
    if (payload?.recording_image) {
      formData.append('recording_image', payload.recording_image);
    }

    const response = await POST({
      url: `${ENDPOINTS.AV_AUTOMATION}/create`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  };

  const updateAVAutomation = async (payload?: {
    data?: IAVAutomationUpdatePayload;
    youtube_image?: File;
    facebook_image?: File;
    recording_image?: File;
  }) => {
    const transformedPayload = transformPayload<IAVAutomationUpdatePayload>(payload?.data);
    const formData = new FormData();
    formData.append('token', transformedPayload);

    if (payload?.youtube_image) {
      formData.append('youtube_image', payload.youtube_image);
    }
    if (payload?.facebook_image) {
      formData.append('facebook_image', payload.facebook_image);
    }
    if (payload?.recording_image) {
      formData.append('recording_image', payload.recording_image);
    }

    const response = await POST({
      url: `${ENDPOINTS.AV_AUTOMATION}/update`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  };

  const deleteAVAutomation = async (payload?: IAVAutomationDeletePayload) => {
    const transformedPayload = transformPayload<IAVAutomationDeletePayload>(payload);

    const response = await DELETE({
      url: `${ENDPOINTS.AV_AUTOMATION}/delete`,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  const getGaugeMeter = async (payload?: any) => {
    const transformedPayload = transformPayload<any>(payload);

    const response = await GET<any>({
      url: `${ENDPOINTS.AV_AUTOMATION}/gauge_meter`,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  const transferMachine = async (payload?: any) => {
    const transformedPayload = transformPayload<any>(payload);
    const response = await POST<any>({
      url: `${ENDPOINTS.AV_AUTOMATION}/transfer_other_machine`,
      params: {
        token: transformedPayload,
      },
    });
    return response.data;
  };

  return {
    getAVAutomation,
    getSingleAVAutomation,
    createAVAutomation,
    updateAVAutomation,
    deleteAVAutomation,
    getGaugeMeter,
    transferMachine,
  };
};
